// @flow
import React from "react";
import Gated from "../../../svg/facilities/is_gated.svg";
import "./gatedIcon.scss";

const GatedIcon = () => <Gated className="c-gated-icon" />;

export default GatedIcon;
